import React from 'react';

import CVDocument from '../document.component';
import { localizedPage, useLocalizedPage } from '../i18n/localized-page';

import english from './locales/privacy.en';

// How both apps handle information. The short version: nothing leaves the
// organisation's own devices and Wi-Fi. The English text applies; locales/
// holds it and its translations.

const PAGES = localizedPage(english, code => import(/* webpackChunkName: "[request]" */ `./locales/privacy.${code}`));

const CaptiVisionPrivacy = () => {
    const [page, lang] = useLocalizedPage(PAGES);

    return (
        <CVDocument
            lang={lang}
            title={page?.title}
            eyebrow={page?.eyebrow}
            lede={page?.lede}
            meta={page?.meta}
            note={page?.note}
            footerCurrent="Privacy">
            {page?.body}
        </CVDocument>
    )
}

export default CaptiVisionPrivacy;
